import { ROUTES } from '#/config/routes';

/** @typedef {'workOrder' | 'transfer' | 'return'} WorkOrderStockOpsPageKey */

export const WORK_ORDER_STOCK_OPS_PAGE_CONFIG = {
  workOrder: {
    title: '工單列表',
    listRoute: ROUTES.workOrder,
  },
  transfer: {
    title: '工單轉倉',
    listRoute: ROUTES.workOrderTransfer,
    createRoute: ROUTES.workOrderTransferCreate,
  },
  return: {
    title: '工單退料',
    listRoute: ROUTES.workOrderReturn,
    createRoute: ROUTES.workOrderReturnCreate,
  },
};

/**
 * list 殼標題列右側：工單／轉倉／退料互跳（不含當前頁）。
 * @param {WorkOrderStockOpsPageKey} currentPage
 */
export function getWorkOrderStockOpsListNavItems(currentPage) {
  if (currentPage === 'workOrder') {
    return [
      { label: '轉倉', to: ROUTES.workOrderTransfer },
      { label: '退料', to: ROUTES.workOrderReturn },
    ];
  }

  if (currentPage === 'transfer') {
    return [
      { label: '工單', to: ROUTES.workOrder },
      { label: '退料', to: ROUTES.workOrderReturn },
    ];
  }

  if (currentPage === 'return') {
    return [
      { label: '工單', to: ROUTES.workOrder },
      { label: '轉倉', to: ROUTES.workOrderTransfer },
    ];
  }

  return [];
}

/**
 * form 殼：僅返回該模式列表（功能切換只留 list header）。
 * @param {WorkOrderStockOpsPageKey} currentPage
 */
export function getWorkOrderStockOpsFormNavItems(currentPage) {
  const config = WORK_ORDER_STOCK_OPS_PAGE_CONFIG[currentPage];
  if (!config?.listRoute) {
    return [];
  }

  return [
    {
      label: '返回列表',
      to: config.listRoute,
      variant: 'outline',
    },
  ];
}
